module.exports = __webpack_public_path__ + "img/bg2.fbbc7a0a.png";